import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import {
	BoldIcon,
	CaseUpperIcon,
	ItalicIcon,
	StrikethroughIcon,
	UnderlineIcon,
} from '@react-email/editor/ui';
import { Tooltip } from '@mantine/core';

interface Props {
	marks: Record<string, boolean>;
	onToggle: (mark: string) => void;
}

export const FormatRow = ({ marks, onToggle }: Props) => {
	const tMipManage = useTranslationMipManage();

	const options = [
		{
			name: 'bold',
			Icon: BoldIcon,
			label: tMipManage('email_templates.editor.inspector.bold', { defaultValue: 'Bold' }),
		},
		{
			name: 'italic',
			Icon: ItalicIcon,
			label: tMipManage('email_templates.editor.inspector.italic', {
				defaultValue: 'Italic',
			}),
		},
		{
			name: 'underline',
			Icon: UnderlineIcon,
			label: tMipManage('email_templates.editor.inspector.underline', {
				defaultValue: 'Underline',
			}),
		},
		{
			name: 'strike',
			Icon: StrikethroughIcon,
			label: tMipManage('email_templates.editor.inspector.strikethrough', {
				defaultValue: 'Strikethrough',
			}),
		},
		{
			name: 'uppercase',
			Icon: CaseUpperIcon,
			label: tMipManage('email_templates.editor.inspector.uppercase', {
				defaultValue: 'Uppercase',
			}),
		},
	];

	return (
		<div data-re-inspector-prop-row="">
			<label data-re-inspector-label="">
				{tMipManage('email_templates.editor.inspector.format', { defaultValue: 'Format' })}
			</label>
			<div data-re-inspector-toggle-group="" role="group">
				{options.map((option) => (
					<Tooltip key={option.name} label={option.label} withArrow>
						<button
							type="button"
							data-re-inspector-toggle-item=""
							data-active={marks[option.name] ? '' : undefined}
							aria-pressed={Boolean(marks[option.name])}
							aria-label={option.label}
							onClick={() => onToggle(option.name)}
						>
							<option.Icon width={16} height={16} />
						</button>
					</Tooltip>
				))}
			</div>
		</div>
	);
};
